import "./SearchInput.scss";

import PropTypes from "prop-types";
import React from "react";
import { FormGroup, InputGroup, Button } from "react-bootstrap";
import { RefluxAction } from "reflux";

import TextInput from "shared/src/components/TextInput";
import AutosuggestInput from "./AutosuggestInput";
import ButtonIcon from "../general/ButtonIcon";
import { debounce } from "shared/src/utils/util";

type Props = {
    className: string;
    initialValue?: string;
    queryOnChange?: boolean;
    onQuery: (x0: string, x1: boolean, x2: string | undefined | null) => void;
    placeholderId?: string;
    enableSuggestions?: boolean;
    partOfGlobalHeader?: boolean;
    value?: string;
    updateSearchInput?: RefluxAction<[string]>;
    isMobile?: boolean;
};

class SearchInput extends React.Component<
    Props,
    {
        value: string;
    }
> {
    debouncedCallOnQuery: any;

    constructor(props: Props) {
        super(props);
        this.state = {
            value: props.initialValue || ""
        };
        this.debouncedCallOnQuery = debounce(this.callOnQuery, 500);
    }

    static contextTypes = {
        intl: PropTypes.object
    };

    static defaultProps = {
        className: ""
    };

    getValue = () => {
        return this.props.value || this.state.value || "";
    };

    callOnQuery = () => {
        if (this.props.queryOnChange) {
            this.props.onQuery(this.getValue().trim(), false, null);
        }
    };

    onChange = (e: any) => {
        if (e && !((e.target as Element).matches("button") || (e.target as Element).matches("i"))) {
            e.preventDefault();
            const query = e.target.value;
            if (this.props.updateSearchInput) {
                this.props.updateSearchInput.trigger(query);
            }

            if (this.props.queryOnChange) {
                this.setState({ value: query }, this.debouncedCallOnQuery);
            } else {
                this.setState({ value: query });
            }
        }
    };

    onClick = (e: any) => {
        if (e) {
            e.preventDefault();
        }
        const value = this.getValue();
        this.props.onQuery(value.trim(), false, null);
    };

    onSuggestionSelect = (selectedQuery: string, facets: string | undefined | null) => {
        if (this.props.updateSearchInput) {
            this.props.updateSearchInput.trigger(selectedQuery);
        }

        this.setState({ value: selectedQuery });

        this.props.onQuery(selectedQuery, true, facets);
    };

    renderInputComponent = (
        inputProps: {
            placeholder: string;
            value: string;
            onChange: React.ChangeEventHandler;
            className: string;
        },
        onSubmit: (e: React.SyntheticEvent<unknown>) => void
    ) => {
        return this.props.partOfGlobalHeader ? (
            <InputGroup className="mfcss_input-group-inset">
                <TextInput {...inputProps} />
                <InputGroup.Button onClick={onSubmit}>
                    <Button
                        bsStyle="primary"
                        className="btn-square"
                        aria-label={this.context.intl.formatMessage({ id: "SD_SEARCH_BUTTON_ARIA_LABEL" })}>
                        <ButtonIcon symbol="magnify" />
                    </Button>
                </InputGroup.Button>
            </InputGroup>
        ) : (
            <InputGroup>
                <TextInput {...inputProps} />
                <InputGroup.Addon onClick={onSubmit} className="clickable">
                    <span className="icon-search" />
                </InputGroup.Addon>
            </InputGroup>
        );
    };

    render() {
        const value = this.getValue();
        const placeholder = this.context.intl.formatMessage({ id: this.props.placeholderId });
        const reactAutoSuggestInputProps = {
            placeholder,
            value: value || "",
            onChange: this.onChange,
            className: this.props.className
        };

        let form;
        if (this.props.enableSuggestions) {
            form = (
                <AutosuggestInput
                    inputProps={reactAutoSuggestInputProps}
                    onQuery={this.onSuggestionSelect}
                    onSubmit={this.onClick}
                    value={value}
                    renderInputComponent={this.renderInputComponent}
                    isMobile={this.props.isMobile}
                />
            );
        } else {
            form = (
                <form onSubmit={this.onClick}>
                    <FormGroup>{this.renderInputComponent(reactAutoSuggestInputProps, this.onClick)}</FormGroup>
                </form>
            );
        }

        return <div className="ex-search-input">{form}</div>;
    }
}

export default SearchInput;
